<template>
  <of-dialog :title="formTitle" @onCancel="cancel" :width="width">
    <div slot="content">
      <el-form ref="form" label-width="120px" :model="dataForm">
        <el-form-item label="消息类型：">
          <p>{{ dataForm.MessageType === 1?'开票消息':'其他' }}</p>
        </el-form-item>
        <el-form-item label="发送人：">
          <p>{{ dataForm.UserName }}</p>
        </el-form-item>
        <el-form-item label="消息内容：">
          <p>{{ dataForm.Content }}</p>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null
    },
    formTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isConfirm: false,
      formVisible: false,
      index: "",
      width: "30%"
    };
  },
  mounted() {
      this.loadData()
  },
  components: {
    OfDialog
  },
  methods: {
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //加载审批步骤
    loadData() {
      if (this.dataForm.Id) {
        let params={Id:this.dataForm.Id}
        api.setInstationRead(params).then(rep => {
        });
      }
    }
  }
};
</script>


<style scoped>
.el-textarea > textarea {
  height: 80px;
}

.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}

.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--primary {
  display: none;
}

.el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--default {
  display: none;
}

.el-input >>> .el-input__prefix {
  margin-left: 75%;
  margin-top: 2%;
}
.el-form >>> .el-form-item {
  margin-bottom: 0;
}
</style>

<style>
.hide .el-button--primary {
  display: none;
}
</style>
